import { Modal } from "@components/modal";
import { FC } from "react";
import { FormSettingsContainer } from "./form-settings-container";

interface FormSettingDialogProps {
  isOpen: boolean;
  onClose: () => void;
  appId?: string;
  formId?: string;
}
export const FormSettingDialog: FC<FormSettingDialogProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} placement="right" onClose={onClose}>
      <FormSettingsContainer onClose={onClose} />
    </Modal>
  );
};
